export const easeOutExpo = [0.16, 1, 0.3, 1] as const

export const easeOutQuint = [0.22, 1, 0.36, 1] as const

export const easeInOutQuart = [0.76, 0, 0.24, 1] as const

export const clamp = (value: number, min = 0, max = 1): number => {
    return Math.min(max, Math.max(min, value))
}

export const range = (value: number, start: number, end: number): number => {
    if (end === start) return value >= end ? 1 : 0

    return clamp((value - start) / (end - start))
}
